// Bridal Gown Order Form - サイズ選択問題を修正
// 配送プロパティは「配送オプション」のみ - 絶対にハードコード
(function() {
  'use strict';

  console.log('🎀 Bridal Gown Order Form script loaded - SIZE FIX VERSION');

  // グローバル状態オブジェクト
  const globalState = {
    selectedVariantId: null,
    selectedColor: '',
    selectedSize: '',
    selectedDelivery: 'standard',
    quantity: 1,
    basePrice: 0,
    variantImageMap: {},
    variantIdMap: {},
    config: null,
    variantOptionNames: [],
    initialized: false
  };

  // カラー選択関数
  window.selectColor = function(element) {
    console.log('=== selectColor called ===');
    
    if (!element || !element.dataset) {
      console.error('Invalid element passed to selectColor');
      return;
    }
    
    try {
      document.querySelectorAll('.color-swatch').forEach(s => {
        s.classList.remove('selected');
        s.style.borderColor = 'transparent';
        s.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      });
      
      element.classList.add('selected');
      element.style.borderColor = '#000000';
      element.style.boxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #000000';
      
      const colorName = element.dataset.colorName;
      globalState.selectedColor = colorName;
      
      if (globalState.variantIdMap[colorName]) {
        globalState.selectedVariantId = globalState.variantIdMap[colorName];
        console.log('Updated variant ID to:', globalState.selectedVariantId);
      }
      
      const colorError = document.getElementById('colorError');
      if (colorError) {
        colorError.classList.add('hidden');
      }
      
      const selectedColorNameDiv = document.getElementById('selectedColorName');
      const selectedColorText = document.getElementById('selectedColorText');
      if (selectedColorNameDiv && selectedColorText) {
        selectedColorText.textContent = colorName;
        selectedColorNameDiv.style.display = 'block';
      }
      
      const variantImage = globalState.variantImageMap[colorName];
      if (variantImage) {
        const mainImage = document.getElementById('mainImage');
        if (mainImage) {
          mainImage.src = variantImage;
          console.log('Changed main image to variant image:', variantImage);
        }
      }
      
      console.log('Color selected:', colorName);
    } catch (error) {
      console.error('Error in selectColor:', error);
    }
  };

  // サイズ選択関数
  window.selectSize = function(element, size) {
    console.log('=== selectSize called ===');
    
    if (!element || !size) {
      console.error('Invalid parameters passed to selectSize');
      return;
    }
    
    try {
      // すべてのサイズオプションから選択状態を削除
      document.querySelectorAll('.size-option').forEach(s => s.classList.remove('selected'));
      
      // クリックされた要素に選択状態を追加
      element.classList.add('selected');
      
      // グローバル状態を更新
      globalState.selectedSize = size;
      
      // hidden inputの値を更新
      const selectedSizeInput = document.getElementById('selectedSize');
      if (selectedSizeInput) {
        selectedSizeInput.value = size;
      }
      
      // エラーメッセージを非表示
      const sizeError = document.getElementById('sizeError');
      if (sizeError) {
        sizeError.classList.add('hidden');
      }
      
      console.log('Size selected:', size);
    } catch (error) {
      console.error('Error in selectSize:', error);
    }
  };

  // 配送オプション選択関数
  // 重要: プロパティ名は絶対に「配送オプション」のみ使用（ハードコード）
  window.selectDelivery = function(element, type) {
    console.log('=== selectDelivery called ===');
    console.log('Type:', type);
    
    if (!element || !type || !globalState.config) {
      console.error('Invalid parameters or config not loaded');
      return;
    }
    
    try {
      document.querySelectorAll('.delivery-option').forEach(d => d.classList.remove('selected'));
      element.classList.add('selected');
      
      globalState.selectedDelivery = type;
      console.log('Updated globalState.selectedDelivery:', globalState.selectedDelivery);
      
      const standardOption = document.getElementById('standardDeliveryOption');
      const expressOption = document.getElementById('expressDeliveryOption');
      
      if (!standardOption || !expressOption) {
        console.error('Delivery option elements not found');
        return;
      }
      
      const deliveryName = type === 'standard' ? 
        standardOption.querySelector('.font-medium').textContent :
        expressOption.querySelector('.font-medium').textContent;
      
      const standardDateRange = document.getElementById('standardDateRange');
      const expressDateRange = document.getElementById('expressDateRange');
      
      const deliveryDateRange = type === 'standard' ?
        (standardDateRange ? standardDateRange.textContent : '') :
        (expressDateRange ? expressDateRange.textContent : '');
      
      // 配送料金の計算
      let deliveryFee = 0;
      if (type === 'express') {
        deliveryFee = globalState.config.expressFee || 0;
        console.log('Express delivery selected, fee:', deliveryFee);
      } else if (type === 'standard' && globalState.config.standardDeliveryFee > 0) {
        deliveryFee = globalState.config.standardDeliveryFee;
        console.log('Standard delivery selected, fee:', deliveryFee);
      }
      
      // 配送プロパティのフォーマット（料金情報を含む）
      let deliveryProperty = `【${deliveryName}・納期(${deliveryDateRange})】`;
      if (deliveryFee > 0) {
        const feeFormatted = (deliveryFee / 100).toLocaleString('ja-JP');
        deliveryProperty += `+${feeFormatted}円`;
      }
      
      console.log('✅ Formatted delivery property:', deliveryProperty);
      
      // 既存の配送関連の hidden input をすべて削除
      const form = document.getElementById('preOrderForm');
      if (form) {
        const existingInputs = form.querySelectorAll('input[type="hidden"]');
        existingInputs.forEach(input => {
          const inputName = input.name || '';
          const inputValue = input.value || '';
          // 配送関連のキーワードをチェック
          if (inputName.includes('配送') || inputName.includes('お届け') || 
              inputValue.includes('配送') || inputValue.includes('お届け') ||
              inputName.includes('delivery') || inputName.includes('shipping')) {
            console.log('🗑️ Removing existing delivery-related input:', inputName, '=', inputValue);
            input.remove();
          }
        });
      }
      
      // 新しい hidden input を作成（プロパティ名は「配送オプション」のみ - 絶対にハードコード）
      const deliveryInput = document.createElement('input');
      deliveryInput.type = 'hidden';
      deliveryInput.id = 'selectedDeliveryOption';
      deliveryInput.name = 'properties[配送オプション]'; // ハードコード - 絶対に変更しない
      deliveryInput.value = deliveryProperty;
      
      if (form) {
        form.appendChild(deliveryInput);
        console.log('✅ Created new hidden input: properties[配送オプション] =', deliveryProperty);
      }
      
      if (typeof updateMinDate === 'function') updateMinDate();
      if (typeof updateTotalPrice === 'function') updateTotalPrice();
      
      console.log('=== selectDelivery completed ===');
    } catch (error) {
      console.error('Error in selectDelivery:', error);
    }
  };

  // 数量更新関数
  window.updateQuantity = function(change) {
    console.log('=== updateQuantity called ===');
    
    try {
      const quantityInput = document.getElementById('quantity');
      if (!quantityInput) {
        console.error('Quantity input not found');
        return;
      }
      
      let newQuantity = parseInt(quantityInput.value) + change;
      if (newQuantity < 1) newQuantity = 1;
      
      quantityInput.value = newQuantity;
      globalState.quantity = newQuantity;
      
      if (typeof updateTotalPrice === 'function') {
        updateTotalPrice();
      }
      
      console.log('Quantity updated to:', newQuantity);
    } catch (error) {
      console.error('Error in updateQuantity:', error);
    }
  };

  // メイン画像変更関数
  window.changeMainImage = function(imageUrl, thumbnail) {
    console.log('=== changeMainImage called ===');
    
    if (!imageUrl || !thumbnail) {
      console.error('Invalid parameters passed to changeMainImage');
      return;
    }
    
    try {
      const mainImage = document.getElementById('mainImage');
      if (mainImage) {
        mainImage.src = imageUrl;
      }
      
      document.querySelectorAll('.thumbnail-container').forEach(t => {
        t.classList.remove('thumbnail-active');
        t.classList.add('thumbnail-inactive');
      });
      
      thumbnail.classList.remove('thumbnail-inactive');
      thumbnail.classList.add('thumbnail-active');
      
      console.log('Main image changed to:', imageUrl);
    } catch (error) {
      console.error('Error in changeMainImage:', error);
    }
  };

  // 最小日付更新関数
  function updateMinDate() {
    try {
      const dateInput = document.getElementById('usageDate');
      if (!dateInput || !globalState.config) return;
      
      const today = new Date();

      // 通常便・お急ぎ便ごとに、最短日数を設定（セクション設定の standardMinDays / expressMinDays を利用）
      const minDays = globalState.selectedDelivery === 'standard'
        ? globalState.config.standardMinDays
        : globalState.config.expressMinDays;

      today.setDate(today.getDate() + minDays);
      const minDate = today.toISOString().split('T')[0];

      // HTMLのmin属性を更新（PC/スマホ共通）
      dateInput.min = minDate;

      // 既に選択されている日付が最短より前なら、自動的に補正
      if (dateInput.value && dateInput.value < minDate) {
        console.log('Usage date was before min; reset to minDate:', minDate);
        dateInput.value = minDate;
      }

      console.log('Minimum date updated to:', minDate);
    } catch (error) {
      console.error('Error in updateMinDate:', error);
    }
  }

  // 合計金額更新関数
  function updateTotalPrice() {
    try {
      if (!globalState.config) {
        console.warn('Config not loaded, cannot update price');
        return;
      }
      
      let total = globalState.basePrice * globalState.quantity;
      
      console.log('=== updateTotalPrice ===');
      console.log('Base price:', globalState.basePrice);
      console.log('Quantity:', globalState.quantity);
      console.log('Selected delivery:', globalState.selectedDelivery);
      
      if (globalState.selectedDelivery === 'express') {
        total += globalState.config.expressFee || 0;
        console.log('Adding express fee:', globalState.config.expressFee);
      } else if (globalState.selectedDelivery === 'standard' && globalState.config.standardDeliveryFee > 0) {
        total += globalState.config.standardDeliveryFee;
        console.log('Adding standard delivery fee:', globalState.config.standardDeliveryFee);
      }
      
      const formattedPrice = (total / 100).toLocaleString('ja-JP');
      
      const currentPriceEl = document.getElementById('currentPrice');
      const totalPriceEl = document.getElementById('totalPrice');
      
      if (currentPriceEl) currentPriceEl.textContent = formattedPrice;
      if (totalPriceEl) totalPriceEl.textContent = formattedPrice;
      
      console.log('Total:', total, 'Formatted:', formattedPrice);
    } catch (error) {
      console.error('Error in updateTotalPrice:', error);
    }
  }
  
  window.updateTotalPrice = updateTotalPrice;

  // 日本語形式の日付フォーマット
  function formatJapaneseDate(date) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日`;
  }

  // 配送日付更新関数
  function updateDeliveryDates() {
    try {
      if (!globalState.config) {
        console.warn('Config not loaded, cannot update delivery dates');
        return;
      }
      
      const today = new Date();
      
      const standardMinDate = new Date(today);
      standardMinDate.setDate(standardMinDate.getDate() + globalState.config.standardMinDays);
      const standardMaxDate = new Date(today);
      standardMaxDate.setDate(standardMaxDate.getDate() + globalState.config.standardMaxDays);
      
      const standardDateRangeEl = document.getElementById('standardDateRange');
      if (standardDateRangeEl) {
        standardDateRangeEl.textContent = `${formatJapaneseDate(standardMinDate)}〜${formatJapaneseDate(standardMaxDate)}`;
      }
      
      const expressMinDate = new Date(today);
      expressMinDate.setDate(expressMinDate.getDate() + globalState.config.expressMinDays);
      const expressMaxDate = new Date(today);
      expressMaxDate.setDate(expressMaxDate.getDate() + globalState.config.expressMaxDays);
      
      const expressDateRangeEl = document.getElementById('expressDateRange');
      if (expressDateRangeEl) {
        expressDateRangeEl.textContent = `${formatJapaneseDate(expressMinDate)}〜${formatJapaneseDate(expressMaxDate)}`;
      }
      
      console.log('Delivery dates updated');
    } catch (error) {
      console.error('Error in updateDeliveryDates:', error);
    }
  }

  // フォームバリデーション関数
  function validateForm() {
    console.log('=== Validating form ===');
    let isValid = true;
    const errors = [];
    
    try {
      if (!globalState.selectedColor) {
        const colorError = document.getElementById('colorError');
        if (colorError) {
          colorError.classList.remove('hidden');
        }
        errors.push('カラーを選択してください');
        isValid = false;
      }
      
      if (!globalState.selectedSize) {
        const sizeError = document.getElementById('sizeError');
        if (sizeError) {
          sizeError.classList.remove('hidden');
        }
        errors.push('サイズを選択してください');
        isValid = false;
      }
      
      const usageDate = document.getElementById('usageDate');
      if (usageDate && !usageDate.value) {
        const dateError = document.getElementById('dateError');
        if (dateError) {
          dateError.classList.remove('hidden');
        }
        errors.push('ご利用日を選択してください');
        isValid = false;
      }
      
      const usageScene = document.getElementById('usageScene');
      if (usageScene && !usageScene.value) {
        const sceneError = document.getElementById('sceneError');
        if (sceneError) {
          sceneError.classList.remove('hidden');
        }
        errors.push('ご利用シーンを選択してください');
        isValid = false;
      }
      
      const policyAgree = document.getElementById('policyAgree');
      if (policyAgree && !policyAgree.checked) {
        const policyError = document.getElementById('policyError');
        if (policyError) {
          policyError.classList.remove('hidden');
        }
        errors.push('利用規約に同意してください');
        isValid = false;
      }
      
      if (!isValid) {
        const errorMessage = '以下の項目を確認してください:\n\n' + errors.join('\n');
        alert(errorMessage);
      }
      
      console.log('Validation result:', isValid);
    } catch (error) {
      console.error('Error in validateForm:', error);
      isValid = false;
    }
    
    return isValid;
  }

  // カートに追加する関数
  async function addToCart(event) {
    event.preventDefault();
    
    console.log('========================================');
    console.log('🛒 FORM SUBMITTED - STARTING CART ADD');
    console.log('========================================');
    console.log('Current globalState:', globalState);
    
    if (!validateForm()) {
      console.log('❌ Form validation failed - stopping submission');
      return;
    }
    
    const button = document.getElementById('addToCartBtn');
    if (!button) {
      console.error('Add to cart button not found');
      return;
    }
    
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<i class="ph ph-spinner ph-spin text-xl"></i><span>追加中...</span>';
    
    try {
      const productData = {
        id: globalState.selectedVariantId,
        quantity: globalState.quantity,
        properties: {}
      };
      
      console.log('Variant ID:', globalState.selectedVariantId);
      console.log('Quantity:', globalState.quantity);
      
      // 配送プロパティを hidden input から取得（唯一の正しいソース）
      const deliveryInput = document.getElementById('selectedDeliveryOption');
      if (deliveryInput && deliveryInput.value) {
        productData.properties['配送オプション'] = deliveryInput.value;
        console.log('✅ Added delivery property: 配送オプション =', deliveryInput.value);
      } else {
        console.error('❌ No delivery input found!');
      }
      
      const blockedKeywords = [
        'お届け', '配送', 'delivery', 'shipping',
        'お取り寄せ', '速達', '納期', '便',
        'express', 'standard', 'お急ぎ',
        'デリバリー', 'はいそう', 'おとどけ'
      ];
      
      const form = document.getElementById('preOrderForm');
      const allInputs = form.querySelectorAll('input, select, textarea');
      console.log('Total form inputs found:', allInputs.length);
      
      allInputs.forEach(input => {
        const inputName = input.name || '';
        const inputValue = input.value || '';
        
        if (!inputName.startsWith('properties[')) {
          return;
        }
        
        const propNameMatch = inputName.match(/properties\[(.*?)\]/);
        if (!propNameMatch) {
          return;
        }
        
        const propName = propNameMatch[1];
        
        if (!inputValue || inputValue.trim() === '') {
          console.log('⏭️ Skipping empty property:', propName);
          return;
        }
        
        if (globalState.variantOptionNames.includes(propName)) {
          console.log('⏭️ Skipping variant option:', propName);
          return;
        }
        
        const containsBlockedKeyword = blockedKeywords.some(keyword => {
          const keywordLower = keyword.toLowerCase();
          const propNameLower = propName.toLowerCase();
          const propValueLower = inputValue.toLowerCase();
          
          return propNameLower.includes(keywordLower) || propValueLower.includes(keywordLower);
        });
        
        if (propName === '配送オプション') {
          console.log('⏭️ Skipping 配送オプション (already added from hidden input)');
          return;
        }
        
        if (containsBlockedKeyword) {
          console.log('❌ BLOCKED delivery-related property:', propName, '=', inputValue);
          return;
        }
        
        productData.properties[propName] = inputValue;
        console.log('✅ Added property:', propName, '=', inputValue);
      });
      
      console.log('========================================');
      console.log('📦 FINAL PRODUCT DATA TO SEND TO CART:');
      console.log(JSON.stringify(productData, null, 2));
      console.log('========================================');
      
      console.log('Final properties count:', Object.keys(productData.properties).length);
      Object.keys(productData.properties).forEach(key => {
        console.log(`  - ${key}: ${productData.properties[key]}`);
      });
      
      console.log('Sending request to /cart/add.js...');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(productData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('❌ Cart add error response:', errorData);
        throw new Error(errorData.description || 'カートへの追加に失敗しました');
      }
      
      const result = await response.json();
      console.log('✅ Cart add result:', result);
      console.log('========================================');
      console.log('✅ CART ADD SUCCESSFUL - REDIRECTING');
      console.log('========================================');
      
      window.location.href = '/cart';
      
    } catch (error) {
      console.error('========================================');
      console.error('❌ ERROR ADDING TO CART');
      console.error('========================================');
      console.error('Error details:', error);
      alert('カートへの追加中にエラーが発生しました。もう一度お試しください。\n\nエラー: ' + error.message);
      button.disabled = false;
      button.innerHTML = originalHTML;
    }
  }

  // アプリ初期化関数
  function initApp() {
    console.log('========================================');
    console.log('🎀 INITIALIZING BRIDAL GOWN ORDER FORM');
    console.log('========================================');
    
    try {
      const productDataJson = document.getElementById('product-data-json');
      if (!productDataJson) {
        console.error('❌ Product data JSON not found');
        return;
      }

      let config;
      try {
        config = JSON.parse(productDataJson.textContent);
        globalState.config = config;
        console.log('✅ Product config loaded:', config);
      } catch (error) {
        console.error('❌ Error parsing product data:', error);
        return;
      }

      globalState.variantOptionNames = config.options.map(opt => opt.name);
      console.log('Variant option names:', globalState.variantOptionNames);

      globalState.selectedVariantId = config.variantId;
      globalState.basePrice = config.basePrice;
      globalState.quantity = 1;
      
      console.log('Initial globalState:', globalState);

      if (config.variants && config.variants.length > 0) {
        config.variants.forEach(variant => {
          if (variant.option1) {
            if (variant.featured_image) {
              globalState.variantImageMap[variant.option1] = variant.featured_image;
            }
            globalState.variantIdMap[variant.option1] = variant.id;
          }
        });
        console.log('Variant image map:', globalState.variantImageMap);
        console.log('Variant ID map:', globalState.variantIdMap);
      }

      let colorMap = {};
      let colors = [];
      
      const colorOption = config.options.find(opt => opt.position === 1);
      if (colorOption && colorOption.values && colorOption.values.length > 0) {
        colors = colorOption.values;
        console.log('Using colors from product variants:', colors);
        
        colors.forEach(color => {
          const colorLower = color.toLowerCase();
          if (colorLower.includes('アイボリー') || colorLower.includes('ivory')) {
            colorMap[color] = '#FFFFF0';
          } else if (colorLower.includes('ホワイト') || colorLower.includes('white')) {
            colorMap[color] = '#FFFFFF';
          } else if (colorLower.includes('ブラック') || colorLower.includes('black')) {
            colorMap[color] = '#000000';
          } else if (colorLower.includes('レッド') || colorLower.includes('red')) {
            colorMap[color] = '#FF0000';
          } else if (colorLower.includes('ブルー') || colorLower.includes('blue')) {
            colorMap[color] = '#0000FF';
          } else if (colorLower.includes('グリーン') || colorLower.includes('green')) {
            colorMap[color] = '#008000';
          } else if (colorLower.includes('イエロー') || colorLower.includes('yellow')) {
            colorMap[color] = '#FFFF00';
          } else if (colorLower.includes('ピンク') || colorLower.includes('pink')) {
            colorMap[color] = '#FFC0CB';
          } else if (colorLower.includes('パープル') || colorLower.includes('purple')) {
            colorMap[color] = '#800080';
          } else {
            colorMap[color] = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
          }
        });
      }
      
      if (colors.length === 0 && config.customColors) {
        console.log('Using custom colors from section settings:', config.customColors);
        const customColorPairs = config.customColors.split(',');
        customColorPairs.forEach(pair => {
          const [name, code] = pair.split(':').map(s => s.trim());
          if (name && code) {
            colors.push(name);
            colorMap[name] = code;
          }
        });
      }
      
      console.log('Final colors:', colors);
      console.log('Color map:', colorMap);

      const colorSwatchesContainer = document.getElementById('colorSwatches');
      if (colorSwatchesContainer && colors.length > 0) {
        colorSwatchesContainer.innerHTML = '';
        
        colors.forEach((color, index) => {
          const swatch = document.createElement('div');
          swatch.className = 'color-swatch';
          swatch.dataset.colorName = color;
          swatch.title = color;
          swatch.onclick = function() { window.selectColor(this); };
          
          const variantImage = globalState.variantImageMap[color];
          
          if (variantImage) {
            swatch.style.backgroundImage = `url(${variantImage})`;
            swatch.style.backgroundSize = 'cover';
            swatch.style.backgroundPosition = 'center';
          } else {
            const bgColor = colorMap[color];
            if (bgColor && bgColor.startsWith('linear-gradient')) {
              swatch.style.backgroundImage = bgColor;
            } else {
              swatch.style.backgroundColor = bgColor || 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            }
          }
          
          swatch.style.width = '56px';
          swatch.style.height = '56px';
          swatch.style.borderRadius = '50%';
          swatch.style.border = '3px solid transparent';
          swatch.style.cursor = 'pointer';
          swatch.style.transition = 'all 0.3s ease';
          swatch.style.display = 'inline-block';
          swatch.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          
          colorSwatchesContainer.appendChild(swatch);
        });
        
        console.log('✅ Color swatches populated:', colors.length);
        
        const firstSwatch = colorSwatchesContainer.querySelector('.color-swatch');
        if (firstSwatch) {
          window.selectColor(firstSwatch);
          console.log('✅ Auto-selected first color:', colors[0]);
        }
      }

      updateDeliveryDates();
      updateMinDate();
      updateTotalPrice();
      
      const standardDeliveryElement = document.getElementById('standardDeliveryOption');
      if (standardDeliveryElement) {
        window.selectDelivery(standardDeliveryElement, 'standard');
        console.log('✅ Default delivery option initialized: standard');
      }

      const form = document.getElementById('preOrderForm');
      if (form) {
        form.addEventListener('submit', addToCart);
        console.log('✅ Form submit handler attached');
      }

      const quantityInput = document.getElementById('quantity');
      if (quantityInput) {
        quantityInput.addEventListener('change', function() {
          globalState.quantity = parseInt(this.value) || 1;
          if (globalState.quantity < 1) {
            globalState.quantity = 1;
            this.value = 1;
          }
          updateTotalPrice();
        });
      }

      // ご利用日入力の変更時にも最短日付チェック（スマホのdateピッカー対策）
      const usageDateInput = document.getElementById('usageDate');
      if (usageDateInput) {
        usageDateInput.addEventListener('change', function() {
          if (typeof updateMinDate === 'function') {
            updateMinDate();
          }
        });
      }

      globalState.initialized = true;
      console.log('========================================');
      console.log('✅ BRIDAL GOWN ORDER FORM INITIALIZED SUCCESSFULLY');
      console.log('========================================');
      
    } catch (error) {
      console.error('========================================');
      console.error('❌ ERROR INITIALIZING APP');
      console.error('========================================');
      console.error('Error details:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
  } else {
    initApp();
  }
})();